module.exports = __webpack_public_path__ + "images/ui/icon_ranking_leaf_normal_7c6a0eae01f9be0481462f68ecfad778.svg";